const strings = {
  name: 'Nome',
  area: 'Área cadastrada',
  email: 'Email',
  cellPhone: 'Celular',
  notFound: 'Nenhum dado encontrado',
}

export default strings
